// extracted by mini-css-extract-plugin
export var askAiIcon = "_nh-j";
export var category = "_nh-9";
export var categoryHeader = "_nh-e";
export var container = "_nh-0";
export var group = "_nh-a";
export var groupItems = "_nh-f";
export var groupSeparator = "_nh-k";
export var loading = "_nh-1";
export var noResults = "_nh-3";
export var placeholder = "_nh-2";
export var resultContent = "_nh-5";
export var resultIcon = "_nh-c";
export var resultItem = "_nh-g";
export var resultMeta = "_nh-8";
export var resultSubtitle = "_nh-7";
export var resultSuffix = "_nh-i";
export var resultTitle = "_nh-6";
export var resultsList = "_nh-4";
export var searchGroup = "_nh-d";
export var selected = "_nh-h";
export var subgroup = "_nh-b";